/**
 * Default parameter values for Simple Memory
 */
export const simpleMemoryDefaults = {
  memoryType: 'buffer',
  maxMessages: 10,
  sessionIdSource: 'auto',
  sessionIdExpression: '{{ $input.sessionId }}',
  includeSystemMessages: false,
  contextWindow: 4096,
  advancedOptions: false
};
